import React, { useState } from 'react';
import me from '../../../assets/me.JPG';
import ViewMyIntroduction from './ViewMyIntroduction';
import ViewMySkill from './ViewMySkill';
import ViewMyExp from './ViewMyExp';
import ViewMyQual from './ViewMyQualification';
import ViewMyAccomplishments from './ViewMyAccomplishments';
import ViewMyReferences from './ViewMyReferences';
import ViewMyExtracurriculars from './ViewMyExtracurriculars';
import ViewMyPersonalInfo from './ViewMyPersonalInfo';
import ViewMyContact from './ViewMyContact';

import {
    BrowserRouter as Router, Switch, Route, Link , useHistory
  } from "react-router-dom";
import { SelectDD , ExternalDD } from '../../../common/dropdowns';


const ViewProfile = ({ toggle }) => {
    const [collapse, setCollapse] = useState(false);
    const togglecollapse = () => setCollapse(!collapse);
    
    return (
        <div className="page-wrapper">          
            <ViewMyIntroduction />
            <ViewMySkill />
            <ViewMyExp/>
            <ViewMyQual/>
            <ViewMyAccomplishments/>
            <ViewMyReferences/>
            <ViewMyExtracurriculars/>
            <ViewMyPersonalInfo/>
            <ViewMyContact/> 
    </div>
)}
export default ViewProfile;